/* ===== Wild Wheelies — shared site behavior (Shopify Dawn port of site.js) =====
   Header/footer are rendered by Liquid sections here, not injected by JS —
   everything below is guarded with existence checks so it's safe to include
   on every template regardless of which sections are present. */
(function () {
  /* ---- Mobile nav toggle ---- */
  var toggle = document.getElementById('navToggle');
  var navLinks = document.getElementById('navLinks');
  if (toggle && navLinks) {
    toggle.addEventListener('click', function () {
      var open = navLinks.classList.toggle('open');
      toggle.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        navLinks.classList.remove('open');
        toggle.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement,
        a = item.querySelector('.faq-a');
      var open = item.classList.toggle('open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
    });
  });

  /* ---- Machine anatomy pin / row sync + auto-cycle ---- */
  (function () {
    var root = document.getElementById('anat');
    if (!root) return;
    var pins = [].slice.call(root.querySelectorAll('.pin'));
    var rows = [].slice.call(root.querySelectorAll('.anat-row'));
    var timer, touched = false;
    function set(i) {
      pins.forEach(function (p) { p.classList.toggle('on', p.dataset.i === i); });
      rows.forEach(function (r) { r.classList.toggle('on', r.dataset.i === i); });
    }
    function stop() {
      touched = true;
      clearInterval(timer);
    }
    pins.concat(rows).forEach(function (el) {
      el.addEventListener('mouseenter', function () { stop(); set(el.dataset.i); });
      el.addEventListener('click', function () { stop(); set(el.dataset.i); });
      el.addEventListener('focus', function () { stop(); set(el.dataset.i); });
    });
    var total = pins.length || 6;
    set('1');
    var n = 1;
    timer = setInterval(function () {
      if (touched) return;
      n = (n % total) + 1;
      set(String(n));
    }, 3800);
  })();

  /* ---- Countdown offer timer (persists across page views) ---- */
  (function () {
    var root = document.getElementById('countdown');
    if (!root) return;
    var KEY = 'ww_deadline';
    var hours = parseInt(root.getAttribute('data-hours') || '3', 10);
    var ms = hours * 60 * 60 * 1000;
    var dl = parseInt(localStorage.getItem(KEY) || '0', 10);
    var now = Date.now();
    if (!dl || dl < now) {
      dl = now + ms;
      localStorage.setItem(KEY, String(dl));
    }
    var hE = document.getElementById('cd-h'),
      mE = document.getElementById('cd-m'),
      sE = document.getElementById('cd-s');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = dl - Date.now();
      if (diff <= 0) {
        dl = Date.now() + ms;
        localStorage.setItem(KEY, String(dl));
        diff = dl - Date.now();
      }
      if (hE) hE.textContent = pad(Math.floor(diff / 3.6e6));
      if (mE) mE.textContent = pad(Math.floor((diff % 3.6e6) / 6e4));
      if (sE) sE.textContent = pad(Math.floor((diff % 6e4) / 1e3));
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ---- Product gallery thumbnail swap ---- */
  (function () {
    var main = document.getElementById('mainImg');
    var btns = document.querySelectorAll('.thumbs button');
    if (!main || !btns.length) return;
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-img');
        btns.forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
      });
    });
  })();

  /* ---- Scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('in');
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  function store(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  /* ---- Tap-to-expand (mobile "How it works" steps + value-stack rows; CSS only collapses below 768px) ---- */
  document.querySelectorAll('.ww-collapse').forEach(function (box) {
    var btn = box.querySelector('.ww-collapse-btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (window.innerWidth >= 768) return;
      var open = box.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---- Mobile sticky buy bar: after the hero/buy box scrolls away, hidden while the offer is on screen ---- */
  (function () {
    var bar = document.getElementById('wwSticky');
    if (!bar) return;
    var triggers = [].slice.call(document.querySelectorAll('[data-ww-sticky-trigger]'));
    var stops = [].slice.call(document.querySelectorAll('[data-ww-sticky-stop]'));
    if (!triggers.length) return;
    var btn = bar.querySelector('a');
    var shown = null;
    // Scroll events already fire at most once per frame; this only reads a few rects, so no extra throttling.
    function update() {
      var vh = window.innerHeight;
      var pastTrigger = triggers.every(function (el) { return el.getBoundingClientRect().bottom <= 0; });
      var stopVisible = stops.some(function (el) {
        var r = el.getBoundingClientRect();
        return r.top < vh && r.bottom > 0;
      });
      var show = pastTrigger && !stopVisible && !document.querySelector('.ww-lead[open]');
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('ww-sticky-on', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('ww:lead', update);
    update();
  })();

  /* ---- Email popup: mobile after N s or N% scroll, desktop on exit intent, once per visitor ---- */
  (function () {
    var dlg = document.getElementById('wwLead');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var KEY = 'ww_lead_seen';
    var shownThisPage = false;
    function open() {
      if (shownThisPage || dlg.open) return;
      shownThisPage = true;
      store(KEY, String(Date.now()));
      dlg.showModal();
      document.dispatchEvent(new Event('ww:lead'));
    }
    function close() {
      dlg.close();
    }
    dlg.addEventListener('close', function () { document.dispatchEvent(new Event('ww:lead')); });
    dlg.querySelector('.ww-lead-x').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    // Back from a submit (success or error): reopen so the visitor sees the result.
    if (/customer_posted=true/.test(location.search) && location.hash === '#wwLeadForm' ||
        dlg.querySelector('[data-lead-success],[data-lead-error]') && location.hash === '#wwLeadForm') {
      open();
      return;
    }
    // Another customer form (newsletter) was just posted: the popup would render its result state, so don't auto-open.
    if (dlg.querySelector('[data-lead-success],[data-lead-error]')) return;
    if (store(KEY)) return;

    var mobile = window.matchMedia('(max-width: 767px), (pointer: coarse)').matches;
    if (mobile) {
      var delay = parseInt(dlg.getAttribute('data-delay') || '40', 10) * 1000;
      var pct = parseInt(dlg.getAttribute('data-scroll') || '60', 10) / 100;
      var timer = setTimeout(open, delay);
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= pct) {
          window.removeEventListener('scroll', onScroll);
          clearTimeout(timer);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) {
          document.removeEventListener('mouseout', onOut);
          open();
        }
      });
    }
  })();

  /* ---- Plan-page preview lightbox ---- */
  document.querySelectorAll('.pp-lightbox').forEach(function (lb) {
    if (typeof lb.showModal !== 'function') return;
    var img = document.createElement('img');
    lb.appendChild(img);
    var scope = lb.closest('.ww-scope') || document;
    scope.querySelectorAll('.pp-card[data-pp-full]').forEach(function (card) {
      card.addEventListener('click', function () {
        img.src = card.getAttribute('data-pp-full');
        img.alt = card.getAttribute('data-pp-alt') || '';
        lb.showModal();
      });
    });
    lb.querySelector('.pp-close').addEventListener('click', function () { lb.close(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener('close', function () { img.removeAttribute('src'); });
  });
})();
